import { Box } from '../../Box/Box.js';
import styled, { keyframes, css } from 'styled-components';

var bounceAndScale = function bounceAndScale(offset) {
  return keyframes({
    '0%, 44%, 100%': {
      transform: 'translateY(0) scale(1)'
    },
    '16%': {
      transform: "translateY(-".concat(offset, "px) scale(1.25)")
    }
  });
};
var DotLoaderStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Dotsstyled__DotLoaderStyled",
  componentId: "sc-ls0dr0-0"
})(function (props) {
  return {
    backgroundColor: props.dotColor
  };
}, css(["animation:", " 1s ease-in-out ", "s infinite;"], bounceAndScale(5), function (props) {
  return props.index * 0.1;
}));

export { DotLoaderStyled };
//# sourceMappingURL=Dots.styled.js.map
